import { MessageCircle } from "lucide-react";
import { ASSETS } from "../data";
import { scrollToId } from "../lib/scroll";
import { openLiveChat } from "../lib/chat";

export const Footer = ({ onBuy }) => {
  return (
    <footer className="relative bg-[#050505] border-t border-white/10">
      {/* Final CTA */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32 text-center">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-accent">// Final Transmission</span>
        <h2 className="mt-6 font-display font-black uppercase tracking-tighter text-[clamp(2.5rem,8vw,7rem)] leading-[0.85]">
          Time to<br /><span className="text-accent">vanish.</span>
        </h2>
        <button
          data-testid="footer-buy-button"
          onClick={onBuy}
          className="group relative mt-12 inline-flex items-center gap-3 bg-white text-black font-mono uppercase tracking-[0.15em] text-sm px-10 py-5 overflow-hidden"
        >
          <span className="absolute inset-0 bg-accent translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]" />
          <span className="relative z-10 group-hover:text-white transition-colors duration-300">Get The Pack</span>
        </button>
        <div className="mt-6">
          <button
            data-testid="footer-free-tips-link"
            onClick={() => scrollToId("#free-tips")}
            className="font-mono text-xs uppercase tracking-[0.2em] text-white/40 hover:text-accent transition-colors underline underline-offset-4 decoration-white/20"
          >
            Not ready? Get 5 free tips first →
          </button>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="Ghost The Grid" className="h-8 w-8 object-cover rounded-sm" />
            <span className="font-display font-extrabold uppercase tracking-tight text-sm">Ghost The Grid</span>
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/30 text-center">
            © {new Date().getFullYear()} GhostTheGrid.com · You are the firewall
          </p>
          <button
            type="button"
            data-testid="footer-contact-link"
            onClick={openLiveChat}
            className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 hover:text-accent transition-colors"
          >
            <MessageCircle size={13} /> Contact / Support
          </button>
        </div>
        <div className="pb-8 flex justify-center">
          <a href="/login" data-testid="footer-admin-link" className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/20 hover:text-white/50 transition-colors">Admin</a>
        </div>
      </div>
    </footer>
  );
};
